import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

function HelpDesk() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState("");

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/helpDeskList",
        {
          uid: search,
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      //console.log("My_Team", responceRight?.data?.data[0]);
      responceRight = responceRight.data?.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];
      responceRight?.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          id: item.id,
          userId: item?.user_id,
          query: item.query,
          queryDate: item.edate,
          ticketId: item.ticket_id,
          executiveId: item.executive_id,
          status:
            item.status === "open" ? (
              <span style={{ color: "red" }}>Open</span>
            ) : (
              <span style={{ color: "green" }}>Closed</span>
            ),
          replyMessage: item.reply_message,
          replyDate: item.reply_date,
          imgName: item.file_name,
          query_type: item.query_type,
          querTypeText: item.subject,
          reply: (
            <>
              <button
                className="btn-info btn btn-lg"
                onClick={() => navigate(`/Reply?Id=${item.id}`)}
                //disabled={item.status === "close" ? true : false}
              >
                View & Reply
              </button>
            </>
          ),
          delete: (
            <>
              <button
                className="btn-danger btn"
                style={{
                  width: "70px",
                  borderRadius: "13px",
                  padding: "8px 2px",
                }}
                onClick={() => Delete(item.id)}
                //disabled={item.status === "close" ? true : false}
              >
                Delete
              </button>
            </>
          ),
          //   orderid: item.orderid,
        });
        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("Error While calling Myteam API", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const Delete = async (id) => {
    let confirm = window.confirm(
      "Are you sure, you want to pay all pending withdrawal request?"
    );
    if (confirm) {
      try {
        let res = await API.post(
          `/DeleteHelpdeskuserById`,
          {
            id: id,
            loginid: userId,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );

        //console.log("res", res);
        if (res.data.data === "success") {
          toast.success("Deleted Successfully !!");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          toast.error(res.data.data);
        }
      } catch (e) {
        console.log("Somthing Error in Massage API", e);
        if (
          e.response.data.showableMessage ==
          "Please login to access this resource"
        ) {
          dispatch(
            updateAuth({ AdminAuth: false, jwt_token: "", userId: null })
          );
          sessionStorage.clear();
          localStorage.clear();
          navigate("/");
        }
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No", accessor: "sr" },
      { Header: "UserId", accessor: "userId" },
      { Header: "Query", accessor: "query" },
      { Header: "Query Date & Time", accessor: "queryDate" },
      { Header: "Ticket ID", accessor: "ticketId" },
      { Header: "Status", accessor: "status" },
      { Header: "Admin Reply", accessor: "replyMessage" },
      { Header: "Reply Date & Time", accessor: "replyDate" },
      { Header: "", accessor: "reply" },
      { Header: "", accessor: "delete" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">HelpDesk</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-3">
                      <input
                        type="text"
                        id="txtuid"
                        onChange={(e) => setSearch(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter UserId"
                        maxLength={6}
                      />
                    </div>
                    <div class="col-md-3">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Search"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <h4>
                      <span></span>
                    </h4>

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelpDesk;
